import {useState} from "react";
import InfoBox from "./info-box/InfoBox";
import Domain from "@material-ui/icons/Domain";
import {AccountCircle} from "@material-ui/icons";
import {useDispatch, useSelector} from "react-redux";
import ClickableDropdown from "../../../ui/dropdowns/clickable-dropdown/ClickableDropdown";
import * as actions from "../../../../store";
import {samlLogout} from "../../../../shared/utils/axiosUtils";
import {useUserInfoStyles} from "./UserInfoStyles";
import PropTypes from "prop-types";
import {AUTHORITY_TYPE, COMPANY_TYPE, OPERATOR} from "../../../../shared/utils/constants/storage";

const UserInfo = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const classes = useUserInfoStyles();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.authReducer.userClaims)
    const company = useSelector((state) => state.authReducer.selectedCompany)
    const companiesCount = useSelector((state) => state.authReducer.companies.count)
    const liveloAssistenzaLoading = useSelector((state) => state.authReducer.companies.liveloAssistenzaLoading)

    const profiloLink = () => {
        window.location.replace(`https://portaleaziende.fastweb.it/profile`);
    }

    const showUsername = () => {
        if (user.typeUser && user.typeUser.toLowerCase() === OPERATOR) {
            return (user.uid);
        } else {
            return user.firstName ? user.firstName : ""
        }
    };

    const showCompanyName = () => {
        let mode = user.appMode === "test" ? " (Test)" : "";
        if (user.typeUser) {
            return company.name + mode;
        }
        return company.name + mode;
    }

    const profileMenuItems = [
        {
            text: "Profilo",
            disabled: false,
            icon: null,
            handleClick: () => {
                profiloLink();
            },
            roles: ''
        },
        {
            text: "Logout",
            disabled: false,
            icon: null,
            handleClick: () => {
                samlLogout();
            },
            roles: ''
        },
    ];

    const handleDropdownOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };


    const handleOpenCompaniesDialog = () => {
        if ((user.companyType === COMPANY_TYPE.FATHER && user.authorityType === AUTHORITY_TYPE.MASTER) ||
            user.typeUser === OPERATOR || Object.keys(user).length === 0) {
            if (companiesCount === 0) {
                if (user.typeUser === OPERATOR || Object.keys(user).length === 0) {
                    dispatch(actions.fetchCompanies(0, 5))
                } else {
                    dispatch(actions.fetchCompanies(0, 5, user.companyId))
                }
            }
            if (!liveloAssistenzaLoading || Object.keys(user).length === 0) {
                props.handleOpenCompaniesDialog();
            }
        }
    }

    const handleClickDelete = () => {
        dispatch(actions.setParentCompany(user.companyId));
    }

    return (
        <>
            <InfoBox
                value={showCompanyName()}
                handleClickDelete={handleClickDelete}
                shouldSwitch={company.integrationId !== user.companyId &&
                    user.typeUser !== OPERATOR &&
                    Object.keys(user).length !== 0}
                icon={<Domain className={classes.infoBoxIcon}/>}
                onClick={handleOpenCompaniesDialog}
                loading={liveloAssistenzaLoading}
            />
            <InfoBox
                value={showUsername()}
                icon={<AccountCircle className={classes.infoBoxIcon}/>}
                onClick={handleDropdownOpen}
            />
            <ClickableDropdown anchorEl={anchorEl}
                               setAnchorEl={setAnchorEl}
                               menuItems={profileMenuItems}/>
        </>
    );
}

UserInfo.propTypes = {
    handleOpenCompaniesDialog: PropTypes.func.isRequired
}

export default UserInfo;
